import { TelecomMediaPageProvider } from "../../context/industryPageProviders";
import IndustryPageLayout from "./IndustryPageLayout";

export default function TelecomMedia() {
  return (
    <TelecomMediaPageProvider>
      <IndustryPageLayout />
    </TelecomMediaPageProvider>
  );
}
